import { QUERIES_KEYS } from "queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { coursegroupsApi, UpdateBlacklistedTrainersBody } from "./coursegroupsApi";

export const useUpdateTrainerBlacklist = (courseGroupId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateBlacklistedTrainersBody) => coursegroupsApi.updateBlacklistedTrainers(courseGroupId, data),
    onSuccess: () => {
      // Invalidate and refetch course group data to get updated blacklist
      queryClient.invalidateQueries({
        queryKey: QUERIES_KEYS.COURSE_GROUP_BY_ID(courseGroupId),
      });
    },
  });
};
